import { orderService } from '../../services/OrderService'

export default {
    name: 'OrderRemarks',
    components: {
    },
    props: {
        OrderId: {
            type: Number,
            requred: true,
        }
    },
    data: () => {
        return {
            loading: true,
            remarks: [],
            fields: [],
            userRemark: '',
        }
    },
    // Fetches posts when the component is created.
    created() {
        var model = this;
        model.fields = [
            {
                key: 'Text', label: 'Observatii', sortable: false, thStyle: 'width:70%'
            },
            {
                key: 'User', label: 'User', sortable: false, thStyle: 'width:30%'
            },
        ];

        orderService.getOrderRemarks(this.OrderId)
            .then(response => {
                model.remarks = response.data;
                model.loading = false;
            })
            .catch(e => {
                showErrorNotification(e);
            });
    },
    methods: {
        save: function () {
            return new Promise((resolve, reject) => {
                orderService.saveOrderRemarks(this.OrderId, this.userRemark)
                    .then(function () {
                        resolve();
                    })
                    .catch(e => {
                        showErrorNotification(e);
                        reject(e);
                    });
            });
        }
    }
}
